<template>
  <BaseButton
    v-hotkey="shortcuts"
    class="toggle-allday"
    :class="{ minimized: isAllDaySlotMinimized }"
    kind="auxiliary"
    :tooltip="{
      text: isAllDaySlotMinimized ? 'Expand' : 'Collapse',
      shortcut: togglePaneActions.topPane.shortcutsDisplay,
    }"
    tooltip-display="always"
    @click="toggle"
  >
    <template #icon>
      <CollapseIcon />
    </template>
  </BaseButton>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";

import { togglePaneActions } from "@/components/actions/actions";
import BaseButton from "@/components/base/BaseButton.vue";
import CollapseIcon from "@/components/icons/CollapseIcon.vue";
import * as inject from "@/components/inject";

import { assignShortcuts, Shortcuts, toggleTopPane } from "../shortcuts";

export default defineComponent({
  components: {
    BaseButton,
    CollapseIcon,
  },
  props: {
    isAllDaySlotMinimized: { type: Boolean, required: true },
  },
  emits: {
    toggleAllDaySlot: () => true,
  },
  setup(_, { emit }) {
    const isInputFocused = inject.isInputFocused();
    const isModalShown = inject.isModalShown();
    const toggle = () => emit("toggleAllDaySlot");
    const shortcuts = computed<Shortcuts>(() => {
      return {
        ...assignShortcuts(
          { isModalShown, isInputFocused },
          toggleTopPane,
          toggle
        ),
      };
    });
    return { shortcuts, toggle, togglePaneActions };
  },
});
</script>
<style scoped lang="scss">
.toggle-allday {
  position: absolute;
  top: 103px;
  inset-inline-start: 10px;
  z-index: $z-index-content-high;
  transform: rotate(90deg);
  &.minimized {
    transform: rotate(-90deg);
  }
}
</style>
